<odl-tab-list alignment="center">
  <odl-tab panel="index">{{ 'INDEX' | translate }}</odl-tab>
  @if (featureFlags.isEnabled('bookmarks')()) {
    <odl-tab panel="bookmarks">{{ 'BOOKMARKS' | translate }}</odl-tab>
  }
  @if (featureFlags.isEnabled('notes')()) {
    <odl-tab panel="notes">{{ 'NOTES' | translate }}</odl-tab>
  }
  @if (showQuestions()) {
    <odl-tab panel="questions">{{ 'QUESTIONS.TAB' | translate }}</odl-tab>
  }

  <odl-tab-panel name="index">
    <nr-toc (nrNavigated)="handleNavigation()"></nr-toc>
  </odl-tab-panel>

  @if (featureFlags.isEnabled('bookmarks')()) {
    <odl-tab-panel name="bookmarks">
      <nr-bookmarks (nrNavigated)="handleNavigation()"></nr-bookmarks>
    </odl-tab-panel>
  }

  @if (featureFlags.isEnabled('notes')()) {
    <odl-tab-panel name="notes">
      <nr-notes (nrNavigated)="handleNavigation()"></nr-notes>
    </odl-tab-panel>
  }

  @if (showQuestions()) {
    <odl-tab-panel name="questions">
      <nr-questions-list (nrNavigated)="handleNavigation()"></nr-questions-list>
    </odl-tab-panel>
  }
</odl-tab-list>
